/**
 * Detect search-engine / LLM / SEO crawlers so listing pages skip TN MapAndLayout +
 * Mercury availability. SSR listing HTML + JSON-LD remain for SEO.
 *
 * Keep pattern in sync with server/api-util/tnSeaticsBotDetect.js
 */

export const TN_SEATICS_BOT_UA_RE = new RegExp(
  [
    'Googlebot',
    'Google-InspectionTool',
    'GoogleOther',
    'Mediapartners-Google',
    'AdsBot-Google',
    'Storebot-Google',
    'APIs-Google',
    'Bingbot',
    'BingPreview',
    'DuckDuckBot',
    'YandexBot',
    'Baiduspider',
    'Applebot',
    'facebookexternalhit',
    'meta-externalagent',
    'Facebot',
    'Twitterbot',
    'LinkedInBot',
    'Slackbot',
    'Discordbot',
    'WhatsApp',
    'TelegramBot',
    'GPTBot',
    'ChatGPT-User',
    'OAI-SearchBot',
    'ClaudeBot',
    'anthropic-ai',
    'Amazonbot',
    'Bytespider',
    'CCBot',
    'PerplexityBot',
    'YouBot',
    'AhrefsBot',
    'SemrushBot',
    'DotBot',
    'MJ12bot',
    'PetalBot',
    'Screaming Frog',
    'SeobilityBot',
    'DataForSeoBot',
    'ia_archiver',
    'archive\\.org_bot',
    'HeadlessChrome',
    'PhantomJS',
    'Puppeteer',
    'Playwright',
    'wget',
    'curl/',
    'python-requests',
    'python-urllib',
    'Scrapy',
    'Go-http-client',
    'Java/',
    '(?:^|[\\s(;])bot(?:[\\s/;)]|$)',
    'crawler',
    'spider',
    'slurp',
  ].join('|'),
  'i'
);

/**
 * @param {string|null|undefined} userAgent
 * @returns {boolean}
 */
export const isLikelyTnSeaticsBotUserAgent = userAgent => {
  const ua = String(userAgent || '').trim();
  if (!ua) {
    return false;
  }
  return TN_SEATICS_BOT_UA_RE.test(ua);
};

/**
 * Browser / SSR: true when navigator UA looks like a crawler.
 * SSR (no navigator) returns false — server API gate still blocks TN for bot requests.
 */
export const isLikelyTnSeaticsBot = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return isLikelyTnSeaticsBotUserAgent(navigator.userAgent || '');
};
